import { render } from "./mobile-default-footer.vue?vue&type=template&id=2810ee87&scoped=true"
import script from "./mobile-default-footer.vue?vue&type=script&lang=js"
export * from "./mobile-default-footer.vue?vue&type=script&lang=js"

import "./mobile-default-footer.vue?vue&type=style&index=0&id=2810ee87&lang=scss&scoped=true"

import exportComponent from "/home/hudson/workspace/103261_ib-gwms-customer-xc-devops/ib-gwms-customer-xc-devops/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2810ee87"]])

export default __exports__